(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zym-collection-hero"] && !Shopify.designMode) return;
  try {
    
  const zymTranslations = new Map([
    ['availability', 'Disponibilité'],
    ['price', 'Prix'],
    ['sort', 'Trier'],
    ['featured', 'En vedette'],
    ['most relevant', 'Plus pertinents'],
    ['best selling', 'Meilleures ventes'],
    ['alphabetically, a-z', 'Ordre alphabétique, A à Z'],
    ['alphabetically, z-a', 'Ordre alphabétique, Z à A'],
    ['price, low to high', 'Prix croissant'],
    ['price, high to low', 'Prix décroissant'],
    ['date, old to new', 'Date, du plus ancien au plus récent'],
    ['date, new to old', 'Date, du plus récent au plus ancien'],
    ['to', 'à'],
    ['in stock', 'En stock'],
    ['out of stock', 'En rupture de stock']
  ]);

  const localizeZymShop = () => {
    document.querySelectorAll('.facets__label, .facets__inputs-list .checkbox__label-text, .sorting-filter__label, .sorting-filter .facets__status, .sorting-filter__select option, .price-facet__separator').forEach((element) => {
      const key = element.textContent.trim().toLowerCase();
      const translation = zymTranslations.get(key);
      if (translation && element.textContent.trim() !== translation) element.textContent = translation;
    });

    document.querySelectorAll('.price-facet__highest-price').forEach((element) => {
      const match = element.textContent.trim().match(/^the highest price is\s*€?\s*(.+)$/i);
      if (match) element.textContent = `Le prix le plus élevé est de ${match[1].trim()} €`;
    });

    document.querySelectorAll('.products-count-wrapper span[role="status"]').forEach((element) => {
      const match = element.textContent.trim().match(/^(\d+)\s+items?$/i);
      if (!match) return;
      const count = Number(match[1]);
      element.textContent = `${count} ${count > 1 ? 'articles' : 'article'}`;
    });
  };

  let zymLocalizationFrame;
  const zymLocalizationObserver = new MutationObserver(() => {
    cancelAnimationFrame(zymLocalizationFrame);
    zymLocalizationFrame = requestAnimationFrame(localizeZymShop);
  });

  localizeZymShop();
  zymLocalizationObserver.observe(document.documentElement, { childList: true, subtree: true });

  } catch(e) { console.error(e); }
})();
})();
